import { AssetClass } from '@/entities/assets'

import { AnalyticsField } from '@types'

import { LOADING_TEXT, UNKNOWN_VALUE, ASSET_FIELD } from '@/const'

export const getAssetById = (
  id: string,
  assetsBunch: Map<string, AssetClass>,
) => {
  const asset = assetsBunch.get(id)
  return asset
}

const getAssetNameById = (id: string, assetsBunch: Map<string, AssetClass>) => {
  const asset = getAssetById(id, assetsBunch)
  return asset?.field<string>(ASSET_FIELD.NAME).value
}

export const getAssetName =
  (
    assetsBunch: Map<string, AssetClass>,
    repositoryName = '',
    defaultText = UNKNOWN_VALUE,
  ) =>
    (id: string) => {
      if (id === AnalyticsField.REPO_ROOT) {
        return repositoryName
      }
      if (assetsBunch.size === 0) {
        return LOADING_TEXT
      }
      return getAssetNameById(id, assetsBunch) || defaultText
    }

const getAssetTypeById = (id: string, assetsBunch: Map<string, AssetClass>) => {
  const asset = getAssetById(id, assetsBunch)
  return asset?.field<string>(ASSET_FIELD.TYPE).value
}

export const getAssetType =
  (assetsBunch: Map<string, AssetClass>) => (id: string) => {
    if (id === AnalyticsField.REPO_ROOT) {
      return ''
    }
    if (assetsBunch.size === 0) {
      return LOADING_TEXT
    }
    return getAssetTypeById(id, assetsBunch) || UNKNOWN_VALUE
  }
